<button 
  class="map__make-payment-button ci-paragraph-p1-semibold"
  (click)="handleMakePaymentClick()"
>
  {{ 'Realizar pago' | translate }}
</button>